export var EchoObject;
(function (EchoObject) {
    let Mutation;
    (function (Mutation) {
        /**
         * Defined in:
         *   {@link file://./../../../dxos/echo/object.proto}
         */
        let Action;
        (function (Action) {
            Action[Action["NOOP"] = 0] = "NOOP";
            Action[Action["DELETE"] = 1] = "DELETE";
            Action[Action["RESTORE"] = 2] = "RESTORE";
        })(Action = Mutation.Action || (Mutation.Action = {}));
    })(Mutation = EchoObject.Mutation || (EchoObject.Mutation = {}));
})(EchoObject || (EchoObject = {}));
//# sourceMappingURL=object.js.map